import {api} from './api'

export const getCurrentOperationApi = (plataforma: string | null) => {
    return api.get('currentoperation/', {params:{plataforma}})
}